export class CountryPresentation {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly code: string,
    public readonly currencyCode: string,
  ) {
  }
}
